import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'TextAreaBlock',
    props: {
        content: {
            type: String,
            required: true,
        },
        useContainer: {
            type: Boolean,
            required: false,
            default: true,
        },
        isSingle: {
            type: Boolean,
            required: false,
            default: false,
        },
        anchor: {
            type: String,
            required: false,
        },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _directive_dompurify_html = _resolveDirective("dompurify-html");
            return (_openBlock(), _createElementBlock("section", {
                id: __props.anchor,
                class: _normalizeClass([{ '!mb-0': __props.isSingle }, "content-section"]),
                "data-text-area-block": ""
            }, [
                _createElementVNode("div", {
                    class: _normalizeClass({
                        'container grid-layout': __props.useContainer,
                    })
                }, [
                    _withDirectives(_createElementVNode("div", {
                        class: _normalizeClass([{ 'col-span-2': __props.useContainer }, "wysiwyg"])
                    }, null, 2), [
                        [_directive_dompurify_html, __props.content]
                    ])
                ], 2)
            ], 10, _hoisted_1));
        };
    }
});
